import {useQuery} from "@tanstack/react-query";
import {sessionQueryOptions} from "../services/session.js";

const useSession = () => useQuery(sessionQueryOptions);

export default useSession;
